export * from "./ConsentAndPayFormRenderer";
